
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"19","viewBox":"0 0 55 37","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.544 18.048c0-5.536.992-9.872 2.976-13.008C5.536 1.904 8.864.336 13.504.336s7.952 1.568 9.936 4.704c2.016 3.136 3.024 7.472 3.024 13.008 0 5.568-1.008 9.936-3.024 13.104-1.984 3.168-5.296 4.752-9.936 4.752S5.536 34.32 3.52 31.152C1.536 27.984.544 23.616.544 18.048zm19.296 0c0-2.368-.16-4.352-.48-5.952-.288-1.632-.896-2.96-1.824-3.984-.896-1.024-2.24-1.536-4.032-1.536-1.792 0-3.152.512-4.08 1.536-.896 1.024-1.504 2.352-1.824 3.984-.288 1.6-.432 3.584-.432 5.952 0 2.432.144 4.48.432 6.144.288 1.632.896 2.96 1.824 3.984.928.992 2.288 1.488 4.08 1.488 1.792 0 3.152-.496 4.08-1.488.928-1.024 1.536-2.352 1.824-3.984.288-1.664.432-3.712.432-6.144zm11.831-7.824c.16-3.2 1.28-5.664 3.36-7.392 2.112-1.76 4.88-2.64 8.304-2.64 2.336 0 4.336.416 6 1.248 1.664.8 2.912 1.904 3.744 3.312.864 1.376 1.296 2.944 1.296 4.704 0 2.016-.528 3.728-1.584 5.136-1.024 1.376-2.256 2.304-3.696 2.784v.192c1.856.576 3.296 1.6 4.32 3.072C54.471 22.112 55 24 55 26.304c0 1.92-.448 3.632-1.344 5.136-.864 1.504-2.16 2.688-3.888 3.552-1.696.832-3.744 1.248-6.144 1.248-3.616 0-6.56-.912-8.832-2.736-2.272-1.824-3.472-4.512-3.6-8.064h6.528c.064 1.568.592 2.832 1.584 3.792 1.024.928 2.416 1.392 4.176 1.392 1.632 0 2.88-.448 3.744-1.344.896-.928 1.344-2.112 1.344-3.552 0-1.92-.608-3.296-1.824-4.128-1.216-.832-3.104-1.248-5.664-1.248h-1.392v-5.52h1.392c4.544 0 6.816-1.52 6.816-4.56 0-1.376-.416-2.448-1.248-3.216-.8-.768-1.968-1.152-3.504-1.152-1.504 0-2.672.416-3.504 1.248-.8.8-1.264 1.824-1.392 3.072h-6.576z","fill":"#000"}})])
          )
        }
      }
    